var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module-toggle-group" }, [
    _c(
      "div",
      {
        staticClass: "toggle-all",
        class: { active: _vm.isActive },
        attrs: { title: _vm.title },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.toggle.apply(null, arguments)
          },
        },
      },
      [
        _c("span", { staticClass: "material-icons" }, [
          _vm._v(_vm._s(_vm.getIcon)),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }